import { ref, defineComponent } from "vue";
export default defineComponent({
    name: "UiAccordion",
    props: {
        title: {
            required: true,
            type: String,
        },
    },
    setup() {
        const isOpen = ref(false);
        const toggleAccordion = () => {
            isOpen.value = !isOpen.value;
        };
        return {
            isOpen,
            toggleAccordion,
        };
    },
});
